import onClickOutside from 'react-onclickoutside'

import { AppStoreBadge, GooglePlayStoreBadge } from '../../shared/components/AppDownloadBadge'

import TextButton from './TextButton'

const GetAppButton = ({ onClick }) => (
    <TextButton className="nav-get-app-btn" onClick={onClick}>
        <T>get.app.title</T>
        <div className="nav-ic-down-arrow" />
    </TextButton>
)

const GetAppDropdown = () => (
    <div className="arrow-box">
        <AppStoreBadge imgClass="nav-ic-download" />
        <div className="spacing" />
        <GooglePlayStoreBadge imgClass="nav-ic-download" />
    </div>
)

GetAppButton.propTypes = {
    onClick: PropTypes.func.isRequired,
}

class GetAppContainer extends Component {
    constructor(props) {
        super(props)

        this.onClick = this.onClick.bind(this)
        this.state = {
            isDropdownActive: false,
        }
    }

    onClick() {
        this.setState({
            isDropdownActive: !this.state.isDropdownActive,
        })
    }
    handleClickOutside() {
        this.setState({
            isDropdownActive: false,
        })
    }

    render() {
        return (
            <div className="nav-get-app-container">
                <GetAppButton onClick={this.onClick} />
                {this.state.isDropdownActive && <GetAppDropdown />}
            </div>
        )
    }
}

export default onClickOutside(GetAppContainer)
